import { FinancialConnectionWithAccounts } from "@common/types/financialConnection";
import { FinancialConnectionDto } from "@common/dto/financialAccount/financial-connection.dto";
import { CreateOauthConnectionDto } from "@common/dto/oauth/create-oauth-connection.dto";
import { rampConnectionContract } from "@common/contracts/ramp-connection.contract";
import { RampCreateConnectionBody } from "@common/schemas/domains/ramp/ramp-connection.schema";
import { backendClient, unwrapResponse } from "./backendClient";
import { getBackendAPIClient } from "./backendAPIClient";

const rampConnectionApiClient = getBackendAPIClient(rampConnectionContract);

export async function createRampConnection(
    data: RampCreateConnectionBody,
): Promise<FinancialConnectionWithAccounts> {
    const { body } = await rampConnectionApiClient.createConnection({
        body: data,
    });
    return FinancialConnectionDto.deserialize(body);
}

export async function fixRampConnection(
    id: number,
    data: CreateOauthConnectionDto,
): Promise<FinancialConnectionWithAccounts> {
    return FinancialConnectionDto.deserialize(
        unwrapResponse(
            await backendClient.post(`/ramp-connection/fix/${id}`, data),
        ),
    );
}
